import { useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { getPayDetailStatementCheck, getPayDetailStatementItem, getPayDetailStatementPdfDownloadUrl } from '../api';

export const useGetPayDetailStatementCheck = (params) => {
  const navigate = useNavigate();

  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['payDetailStatementCheck', params],
    queryFn: () => getPayDetailStatementCheck({ ...params }),
    retry: false,
    onError: (error) => {
      const isServerError =
        error?.response?.status === 500 ||
        error?.message?.includes('500') ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ERR_BAD_RESPONSE';

      if (isServerError) {
        navigate('/receipt/expired');
      }
    },
  });

  return { data };
};

export const useGetPayDetailStatementItem = (params) => {
  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['payDetailStatementItem', params],
    queryFn: () => getPayDetailStatementItem({ ...params }),
  });

  return { data };
};

export const useGetPayDetailStatementPdfDownloadUrl = (params) => {
  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['payDetailStatementPdfDownloadUrl', params],
    queryFn: () => getPayDetailStatementPdfDownloadUrl({ ...params }),
  });

  return { data };
};
